import * as React from "react";
import { cn } from "../../lib/utils";

export interface IconBtnProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}

export const IconBtn = React.forwardRef<HTMLButtonElement, IconBtnProps>(
  ({ className, label, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      className={cn(
        "inline-flex h-9 w-9 items-center justify-center",
        "bg-transparent border border-border-light rounded-md text-onyx",
        "transition-colors duration-fast ease-standard",
        "hover:bg-white-warm",
        "focus-visible:outline-none focus-visible:shadow-goldRing",
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
);
IconBtn.displayName = "IconBtn";
